module.exports = __webpack_public_path__ + "assets/img/10october_light.22a2d301.jpeg";